import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AddEditUserService } from '../../../../../../services/add-edit-user.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'user-settings-cashier-settings',
  templateUrl: './cashier-settings.component.html',
  styleUrls: ['./cashier-settings.component.scss']
})
export class CashierSettingsComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    var usersAccounts = changes['usersAccounts'] != undefined ? changes['usersAccounts'].currentValue : [];
    var defSettings = changes['usersAccounts'] != undefined ? changes['usersAccounts'].currentValue : [];
    this.gridAccounts = usersAccounts;
    this.accounts.emit(this.gridAccounts);
    if (this.defaultSettings == null) {
      this.userManage.getDefaultSettings((res) => {
        this.defaultSettings = res;
      },
        (err) => { });
    }
  }
  settings = JSON.parse(sessionStorage.getItem("branchSettings"));
  CanCancelOutboundReceipts: any;
  AllowOutboundDiscount: any;
  AllowInboundDiscount: any;
  AllowPrintingMultipleLabels: boolean;
  @Input() type;
  @Input() Enabled = false;
  @Input() defaultSettings = {};
  @Output() cashierSettings = new EventEmitter();
  @Output() accounts = new EventEmitter();
  reports: any = {};
  userAccounts = [];
  gridAccounts = [];
  tempArray = [];
  paymentDevices = [];
  @Input('usersAccounts') usersAccounts;

  constructor(
    private userManage: AddEditUserService,
    private toaster: ToastrService,
    private translate: TranslateService) {

    this.CanCancelOutboundReceipts = this.settings.filter(x => x.Key == 23)[0] != undefined ? this.settings.filter(x => x.Key == 23)[0].Value : false;
    this.AllowOutboundDiscount = this.settings.filter(x => x.Key == 10)[0] != undefined ? this.settings.filter(x => x.Key == 10)[0].Value : false;
    this.AllowInboundDiscount = this.settings.filter(x => x.Key == 9)[0] != undefined ? this.settings.filter(x => x.Key == 9)[0].Value : false;
    if (this.settings.find(m => m.Key = 31))
      this.AllowPrintingMultipleLabels = this.settings.find(m => m.key = 31).Value == "True"
  }

  emitSetttings() {
   
    this.cashierSettings.emit(this.defaultSettings)
  }

  existAccount(array, obj) {
    var index = array.findIndex(function (item, i) {
      return item.Number === obj.Number;
    });
    if (index > -1)
      return true;
    else
      return false;
  }

  addAccount(account) {
    this.userAccounts = this.gridAccounts;
    if (!this.existAccount(this.userAccounts, account)) {
      this.userAccounts.push(account);
      if (this.gridAccounts.length == 1) {
        this.gridAccounts[0].IsDefault = true;
      }
    }
    else {
      this.toaster.warning(`${this.translate.instant('pages.userModification.userSettings.cashierSettings.existAccount')}`)
    }
    this.accounts.emit(this.gridAccounts);
  }

  removeAccount(accountNumber) {
    var isDefaultAccount = this.gridAccounts.find(x => x.Number == accountNumber).IsDefault;
    this.userAccounts = this.gridAccounts;
    this.userAccounts.splice(this.userAccounts.findIndex(x => x.Number == accountNumber), 1);
    this.gridAccounts = this.userAccounts;
    if (isDefaultAccount && this.gridAccounts.length > 0) {
      this.gridAccounts[0].IsDefault = true;
    }
    this.accounts.emit(this.gridAccounts);
  }

  valid = true;

  MaximumDiscountOutboundpercentageValidationText = '';

  validateMaximumDiscountOutboundpercentage() {

    var maximumDiscountOutboundPercentage = this.settings.filter(x => x.Key == 7)[0].Value;
    var currentSettings = this.defaultSettings as any;
    if (currentSettings.MaximumDiscountPercentageOutbound > maximumDiscountOutboundPercentage) {
      this.valid = false;
      currentSettings.MaximumDiscountPercentageOutbound = maximumDiscountOutboundPercentage;
      this.MaximumDiscountOutboundpercentageValidationText = `${this.translate.instant('pages.userModification.userSettings.cashierSettings.maxAllowPer')} <b>" + ${maximumDiscountOutboundPercentage} + "</b>`;
      this.defaultSettings = currentSettings
    }
    else {
      this.valid = true;
      this.MaximumDiscountOutboundpercentageValidationText = '';
    }
  }

  chooseDefaultAccount(accountNumber) {
    for (var i = 0; i < this.gridAccounts.length; i++) {
      this.gridAccounts[i].IsDefault = false;
    }
    this.gridAccounts.find(x => x.Number == accountNumber).IsDefault = true;
    this.accounts.emit(this.gridAccounts);
  }

  ngOnInit() {

    this.userManage.getReports((res) => {
      var resp = res as any[];

console.log("getReports", resp);

      this.reports = {
        labelReport: resp.filter(x => x.reportTypeId == 1)[0],
        receiptReport: resp.filter(x => x.reportTypeId == 2)[0],
        taxInvoicesReport: resp.filter(x => x.reportTypeId == 3)[0],
        cashoutsReport: resp.filter(x => x.reportTypeId == 4)[0],
        SecondLabelReport: resp.filter(x => x.reportTypeId == 5)[0],
      }
    }, (err) => { })

    this.getPaymentDevices();
  }

  getPaymentDevices() {
    this.userManage.getPaymentDevices('All', (res) => {
      this.paymentDevices = res;
    }, (err) => { });
  }
}
